import { c as _c } from "react/compiler-runtime";
import { TEAM_AVATAR_BACKGROUND } from "@styles/common-colors";
import { NO_TRANSLATE_CLASS, TeamIcon, UserCardItem, useToast } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { useMembersUtils } from "@hooks/use-member-utils";
import { TEAM_DISPLAY_NAME } from "@src/constants/team-constants";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
import { isUserSnapshotAdmin } from "@utils/permission-control/snapshot-permission-control";
import { capitalizeFirstLetter } from "@utils/string-utils";
import { getPendingUserIcon } from "@utils/user-utils";
/** Component that renders a snapshot member using the UserCardItem component */
export function SnapshotMember(t0) {
  const $ = _c(36);
  const {
    member,
    snapshot,
    onSelectOption
  } = t0;
  const {
    openToast
  } = useToast();
  const {
    openProfilePage,
    openViewTeamMembers
  } = useMembersUtils();
  let t1;
  if ($[0] !== member) {
    t1 = FaroCoreApiUtils.Member.isTeam(member);
    $[0] = member;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isMemberTeam = t1;
  let t2;
  if ($[2] !== snapshot) {
    t2 = isUserSnapshotAdmin(snapshot);
    $[2] = snapshot;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const shouldHideRemoveOption = !t2;
  let t3;
  if ($[4] !== isMemberTeam || $[5] !== openProfilePage || $[6] !== openToast || $[7] !== openViewTeamMembers) {
    t3 = function openProfileOrTeamMembersClick(member_0) {
      if (isMemberTeam) {
        if (member_0?.id) {
          openViewTeamMembers({
            teamId: member_0.id
          });
        } else {
          openToast({
            title: `${capitalizeFirstLetter(TEAM_DISPLAY_NAME)} profile page cannot be opened`,
            message: `The ${TEAM_DISPLAY_NAME} ID is not available. Please reload the page to try again.`,
            variant: "error"
          });
        }
      } else {
        openProfilePage({
          member: member_0,
          source: "user more info menu snapshot member list"
        });
      }
    };
    $[4] = isMemberTeam;
    $[5] = openProfilePage;
    $[6] = openToast;
    $[7] = openViewTeamMembers;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const openProfileOrTeamMembersClick = t3;
  const t4 = isMemberTeam ? "View Members" : "Profile";
  let t5;
  if ($[9] !== member || $[10] !== openProfileOrTeamMembersClick) {
    t5 = () => openProfileOrTeamMembersClick(member);
    $[9] = member;
    $[10] = openProfileOrTeamMembersClick;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== isMemberTeam || $[13] !== member) {
    t6 = isMemberTeam ? <TeamIcon /> : getPendingUserIcon(member);
    $[12] = isMemberTeam;
    $[13] = member;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = FaroCoreApiUtils.Member.isMemberActive(member) ? "nameOnly" : "emailOnly";
  let t8;
  if ($[15] !== isMemberTeam) {
    t8 = isMemberTeam ? {
      bgcolor: TEAM_AVATAR_BACKGROUND
    } : undefined;
    $[15] = isMemberTeam;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = isMemberTeam ? "" : member.email;
  let t10;
  if ($[17] !== member.identity || $[18] !== member.name || $[19] !== member.thumbnailUrl || $[20] !== t9) {
    t10 = {
      name: member.name,
      identity: member.identity,
      email: t9,
      profileImageUrl: member.thumbnailUrl,
      userRole: "Snapshot Viewer"
    };
    $[17] = member.identity;
    $[18] = member.name;
    $[19] = member.thumbnailUrl;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = [{
      key: "RESOURCE_VIEWER",
      label: "Snapshot Viewer",
      value: "RESOURCE_VIEWER"
    }];
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== member || $[24] !== onSelectOption) {
    t12 = option => onSelectOption(option, member);
    $[23] = member;
    $[24] = onSelectOption;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== member.identity || $[27] !== shouldHideRemoveOption || $[28] !== t10 || $[29] !== t12 || $[30] !== t4 || $[31] !== t5 || $[32] !== t6 || $[33] !== t7 || $[34] !== t8) {
    t13 = <Box className={NO_TRANSLATE_CLASS}><UserCardItem key={member.identity} shouldShowProfileCard={true} actionButtonLabel={t4} onProfileCardClick={t5} shouldHideRemove={shouldHideRemoveOption} icon={t6} displayOption={t7} avatarSx={t8} userInfo={t10} selectedOption="RESOURCE_VIEWER" dropdownOptions={t11} onChange={t12} /></Box>;
    $[26] = member.identity;
    $[27] = shouldHideRemoveOption;
    $[28] = t10;
    $[29] = t12;
    $[30] = t4;
    $[31] = t5;
    $[32] = t6;
    $[33] = t7;
    $[34] = t8;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  return t13;
}